import { CheckBox } from '@design/components/checkbox/CheckBox';
import { Icon } from '@design/components/icon/Icon';
import * as Radix from '@radix-ui/react-dropdown-menu';
import filterStyles from '@terminal/components/filter/Filter.module.scss';
import React, { MouseEvent } from 'react';

type AddMoreFilterOptionProps = {
  name: string;
  filterKey: string;
  locked: boolean;
  isChecked?: boolean;
  handleClick: (option: string) => void;
};

export const AddMoreFilterOption = ({
  filterKey,
  name,
  locked,
  isChecked,
  handleClick,
}: AddMoreFilterOptionProps) => {
  const onClick = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    handleClick(filterKey);
  };

  if (locked) {
    return (
      <Radix.Item className={filterStyles.item} disabled>
        <span
          className={filterStyles.menuItemLeftIndicator}
          data-menu-item-indicator
        />
        <div className={filterStyles.itemText} data-item-text>
          <Icon iconName="Lock" size={16} className={filterStyles.lockedIcon} />
          <span className={filterStyles.itemLabelLocked}>{name}</span>
        </div>
      </Radix.Item>
    );
  }

  return (
    <Radix.CheckboxItem className={filterStyles.checkboxItem} onClick={onClick}>
      <div className={filterStyles.itemText} data-item-text>
        <CheckBox
          label={<span className={filterStyles.itemLabel}>{name}</span>}
          name={filterKey}
          checked={isChecked}
        />
      </div>
    </Radix.CheckboxItem>
  );
};
